import Builder from './components/Builder'
import apiFetch from "@wordpress/api-fetch";

document.addEventListener("DOMContentLoaded", DOMContentLoadedImport);

function DOMContentLoadedImport() {


    var appData = {
        name: "Product Slider for WooCommerce ",
        version: "1.0.0",
        demoUrl: "https://demo.pickplugins.com/woocommerce-products-slider/",
        reviewsUrl: "https://wordpress.org/support/plugin/woocommerce-products-slider/reviews/#new-post/"
    }

    window.PostGrid = {};
    window.PostGrid = appData;

    apiFetch({
        path: "/wcps/v2/get_options",
        method: "POST",
        data: { option: "wcps_settings" },
    }).then((res) => {
        if (res.length != 0) {
            var resX = { ...res };
            var license_key = resX?.license_key;


            window.PostGrid = { ...appData, license_key: license_key };


        }
    });

    // console.log(window.PostGrid)

    setTimeout(() => {

        var builderWrap = document.querySelector('#builder');


        if (builderWrap != null) {
            wp.element.render(<Builder appData={appData} />, builderWrap)
        }
    }, 2000)



}



